<template>
    <div class="home-view">
        <LanguageBar v-if="isMobile == false"></LanguageBar>
        <NavigationBar></NavigationBar>
        <router-view />
        <TheFooter></TheFooter>
    </div>
</template>
  
<script setup>
// @ is an alias to /src
import LanguageBar from '../components/Model/LanguageBar.vue'
import TheFooter from '../components/Model/TheFooter.vue'
import NavigationBar from '../components/Model/NavigationBar.vue'

import { onMounted, onUnmounted, ref } from 'vue';

const isMobile = ref(false);

function checkMobile() {
  isMobile.value = typeof window !== 'undefined' ? window.innerWidth <= 835 : false;
}

onMounted(() => {
  checkMobile();
  window.addEventListener("resize", checkMobile);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
});
</script>
  
<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow: hidden;
}

body {
    margin: 0;
}

.home-view {
    margin: 0;
    padding: 0;
}
</style>
  
  
